<template lang="pug">
  title-tab(
    :msg="$t('title.template-number')" 
    :had-data='hadData'
  )
    template(#buttonAppend)
      v-btn.toolbartab(
        text 
        color='orange' 
        dark 
        @click='openCreateDialog'
      )
        v-icon mdi-plus
        | {{ $t('button.create-template-number') }}

    n-data-table-card-result.mt-3(
      :headers='headers'
      :items='items'
      :meta='meta'
      @nextpage="nextpage"
      @click:row='openEditModal'
    )
      template(#item.leftActionEffectToCard='{ item }')
        v-btn(
          icon
          x-small
          @click.stop='deleteTemplate(item.uuid)'
        )
          v-icon
            | mdi-delete
      template(#item.rightActionEffectToCard='{ item }')
        | {{item.updated_at}}

    dialog-create-number(
      ref='dialogCreate'
      @submit='load'
    )
    dialog-number-detail(
      ref='dialogDetail'
      @submit='load'
    ) 

</template>
<script>  
import { numberTemplate as apiNumberTemplate } from '@/apis'
import dialogCreateNumber from '@/views/TemplateNumber/childs/dialogCreateNumber'
import dialogNumberDetail from '@/views/TemplateNumber/childs/dialogNumberDetail'

export default {
  components : { 
    dialogCreateNumber,
    dialogNumberDetail,  
  },
  data: () =>({   
    page:1,
    hadData : false,
    items : [],
    meta:{}, 
    headers:[ 
      { text: 'table.name', value: 'name'},
      { text: 'table.amount', value: 'total_number' },
      { text: 'table.updated-at', value: 'updated_at', IsHideCard:true },
      { text: 'table.remove', value: 'leftActionEffectToCard' },
    ] 
  }), 
  async created () {    
    await this.load ()  
  },
  methods:{  
    async load (params = {}) { 
      params.page = this.page

      const [err,data,,meta] = await apiNumberTemplate.get(params)
 
      this.hadData = true 
      if(err){ 
        this.$alert('',err,'warning') 
        return
      }
      this.items = data  
      this.meta = meta
    },

    nextpage (value) {
      this.page = value
      this.load ()
    }, 

    async deleteTemplate (uuid) {  
      this.$ga.event('Button', 'DeleteTemplateNumber', 'TemplateNumberPage','' )
      const confirm = await this.$confirm('',this.$t('confirm.remove-template-number'),'warning')
      
      if(!confirm) {
        return
      }
      
       
      this.$ga.event('Button', 'DeleteTemplateNumberConfirm', 'TemplateNumberPage','' )
      const [err, , message] = await apiNumberTemplate.delete(uuid)
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }

      this.$alert('',message,'success') 
      this.load () 
    }, 

    openCreateDialog () {
        this.$ga.event('Button', 'OpenCreateTemplateNumber', 'TemplateNumberPage','' )
        this.$refs.dialogCreate.open()
    },

    async openEditModal (temp) {
      this.$ga.event('Button', 'OpenEditTemplateNumber', 'TemplateNumberPage','' )
      const [err, data ] = await apiNumberTemplate.getById(temp.uuid)
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }

      this.$refs.dialogDetail.open(data)  
    },  
  } 
}
</script> 